"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Generates an array of Fibonacci sequence numbers up to the X amount.
 */
exports.default = (x) => {
    if (x === 1) {
        return [0];
    }
    const fib = [0, 1];
    if (x === 2) {
        return fib;
    }
    for (let i = fib.length; i < x; i++) {
        fib[i] = fib[i - 2] + fib[i - 1];
    }
    return fib;
};
